import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";

import { useropen } from '../../redux/userInfo';
import { open, close } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Brepingtable1 from '../../component/Brepingtable1';
import Mainbanners from '../../component/Mainbanners';
import MainbannersTable from '../../component/MainbannersTable';
import moment from 'moment';

import * as APIS from "../../utils/service";


export default function Test({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [inputArr, setinputArr] = useState([]);   
    const [mb_id, setmb_id] = useState('');   
    const [mb_pass, setmb_pass] = useState('');   

    useEffect(() => {
        const script = document.createElement('script');
        const callBackFunc = document.createTextNode(
            "function result(result) {" +
                "try {" +
                    "result = JSON.parse(result);" +
                    "document.querySelector('#result').value = JSON.stringify(result, null, 4);" +
                "} catch (error) {" +
                    "document.querySelector('#result').value = result;" +
                "}" +
            "}");
        script.appendChild(callBackFunc);
        document.body.appendChild(script);
    }, []);
    // 운영) cert.mobile-ok.com (218.50.1.150)
    // 개발) scert.mobile-ok.com (218.50.1.156)
    const mok_popup = () => {
        window.MOBILEOK.process("https://api.maemul.net/mok_std_request", "WB", "result");
    }

    return(
        <>
<button onClick={() => {
    mok_popup();
}}>본인확인 시작(팝업)</button>
        asdfasdf

        <div>
                        <div>
                        <textarea id="result" rows="20"></textarea>
                        </div>
                    </div>
                            
                    <iframe src="https://maemul.oopy.io/" style={{ width: '100%', height: 500 }} />
        </>
    )
}
